import {Form, Formik} from 'formik'
import {Fragment, useState, useEffect} from 'react'
import * as Yup from 'yup'

import Logo from '../../../_metronic/assets/everyvisit-logo.svg'
import LogoMc from '../../../_metronic/assets/mc-logo.svg'

import StartedForm from '../components/Form2'
// import PaymentInfo from '../components/Payment'

import {useIntl} from 'react-intl'
import {useNavigate} from 'react-router-dom'
import {toast} from 'react-toastify'
import submitForm from '../services/submitForm'
import {useMerchantData} from '../hook'
import {Stepper} from '../components/Stepper'

export default function MerchantForm() {
  const intl = useIntl()
  const router = useNavigate()
  const {merchantData, merchantDataSet} = useMerchantData()

  const [list] = useState<{countries: any[]; cities: any[]; regions: any[]}>({
    countries: [],
    cities: [],
    regions: [],
  })

  const errorTranslate = intl.formatMessage({id: 'AUTH.BECOME_MEMBER.ERROR'})
  const [isLoading, setIsLoading] = useState(false)

  const onSubmit = async (values: any) => {
    setIsLoading(true)
    const {merchantID, name, surname, email, phone, titleID, check} = values

    //+1, (), -, space remove
    let newPhone = phone.replace(/\+1|\(|\)|-|\s/g, '')

    if (!check) {
      toast.error(intl.formatMessage({id: 'AUTH.BECOME_MEMBER.ACCEPT'}), {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: 'light',
      })

      setIsLoading(false)
      return
    }

    merchantDataSet(values)

    const response = await submitForm({
      merchantID,
      name,
      surname,
      email,
      phone: newPhone,
      titleID,
    })

    if (response.status) {
      setTimeout(() => {
        router('/become-a-merchant/pricing')
      }, 1000)
    } else {
      toast.error(response.message || errorTranslate, {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
        theme: 'light',
      })
    }

    setIsLoading(false)
  }

  const validSchema = Yup.object().shape({
    merchantId: Yup.string(),
    merchantName: Yup.string().required(
      intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})
    ),
    merchantEmail: Yup.string()
      .email(intl.formatMessage({id: 'GLOBAL.VALIDATION.EMAIL'}))
      .max(100, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 100}))
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    isoName: Yup.string().required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    isoid: Yup.string().required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    updateDateAndTime: Yup.string().required(
      intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})
    ),
    name: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .max(50, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 50})),
    surname: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .max(50, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 50})),
    email: Yup.string()
      .email(intl.formatMessage({id: 'GLOBAL.VALIDATION.EMAIL'}))
      .max(100, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 100}))
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
    phone: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      // if include _
      .matches(/^[^\_]+$/, intl.formatMessage({id: 'GLOBAL.VALIDATION.PHONE'})),
    // .matches(/^\+1 \(\d{3}\) \d{3}-\d{4}$/, intl.formatMessage({ id: 'GLOBAL.VALIDATION.PHONE' })),
    check: Yup.boolean().oneOf(
      [true],
      intl.formatMessage({id: 'GLOBAL.VALIDATION.AGREEMENT_REQUIRED'})
    ),
    titleID: Yup.string().required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})),
  })

  /*   useEffect(() => {
    if (!merchantData.merchantID) {
      router('/')
    }
  }, [merchantData.merchantID, router]) */

  return (
    <Fragment>
      {false ? (
        <></>
      ) : (
        <>
          <div className='d-flex flex-column flex-root px-10 bg-white' id='kt_app_root'>
            <div className='flex-column flex-column-fluid bg-white' id='kt_app_page'>
              <div className='flex-column-fluid'>
                <div id='' className=''>
                  <div className='card'>
                    <div
                      className='container-fluid d-flex align-items-stretch justify-content-between pt-8'
                      id='kt_app_header_container'
                    >
                      <div className='app-header-logo d-flex align-items-center ps-lg-2 me-lg-10'>
                        <a href='/sign-in'>
                          <img alt='Logo' src={LogoMc} className='h-25px' />
                          <img alt='Logo' src={Logo} className='h-35px' />
                        </a>
                      </div>
                    </div>
                    <Stepper activeStep={1} />

                    <Formik
                      enableReinitialize
                      initialValues={merchantData}
                      validationSchema={validSchema}
                      onSubmit={onSubmit}
                    >
                      {({errors, touched, values, setFieldValue, setTouched, handleSubmit}) => (
                        <Form>
                          <div className='d-flex justify-content-start align-items-start mt-2 gap-10'>
                            <StartedForm
                              token={merchantData.token}
                              errors={errors}
                              touched={touched}
                              setTouched={setTouched}
                              list={list}
                              values={values}
                              setFieldValue={setFieldValue}
                              isLoading={isLoading}
                              setIsLoading={setIsLoading}
                              handleSubmit={handleSubmit}
                            />
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </Fragment>
  )
}
